import React from 'react';
import PropTypes from 'prop-types';

function Iframe({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 10L6.5 6.5M10 10V7M10 10H7" />
      <rect width="9" height="9" x="11" y="11" rx="2" />
      <path d="M9.516 19s-3.03-.024-3.94-.024c-.91 0-1.576-.66-1.576-1.576V5.58c0-.913.662-1.578 1.576-1.578h11.82c.914 0 1.574.665 1.574 1.577v3.94" />
    </svg>
  );
}

Iframe.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Iframe;
